import { IFilaMainQuestion, IModelMainQuestion } from '../../model/candidato-api'

export class MainQuestion {
  data_mq: IModelMainQuestion
  constructor(mq: IModelMainQuestion) {
    this.data_mq = mq
  }

  update_mq(mq: IModelMainQuestion) {
    this.data_mq = mq
  }
}

export class MainQuestionEdit extends MainQuestion {
  data: IFilaMainQuestion
  nuevoreg = false
  constructor(mq: IFilaMainQuestion) {
    super(mq.mq)

    this.data = mq
  }

  update(response: IFilaMainQuestion) {
    super.update_mq(response.mq)

    this.data = response
    this.nuevoreg = false
  }
}
